module.exports = __webpack_public_path__ + "static/media/bimini_02.2d3b3d33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/bimini_02.jpg
// module id = 636
// module chunks = 0